
import { defineComponent, PropType } from "vue";
import Avatar from "vue-avatar-component";
interface TicketInterface {
  id: number;
  contactoRut: string;
  contactoNombre: string;
  contactoEmail: string;
  fechaTicket: Date;
  fechaRespuesta?: Date;
  respondido: boolean;
  respuesta: string;
  comentario: string;
}

export default defineComponent({
  name: "widget-3",
  props: {
    widgetClasses: String,
    currentTicket: Object as PropType<TicketInterface>,
  },
  components: {
    Avatar,
  },
  methods: {
    formatDate(value) {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
});
